import { gql } from '@apollo/client';

export const GET_VECTORS_FOR_BOUNDING_BOX = gql`
	query (
		$input: Input_farm_nurture_core_contracts_mva_GetVectorsForBoundingBoxRequest!
	) {
		getVectorsForBoundingBox(input: $input) {
			statusResult {
				status
				errorCode
				errorMessages
			}
			mapResults {
				geoStatusResult
				placeDataResult {
					placeNamespace
					placeSourceType
					placeVisibleType
					tileResults {
						mapTile {
							zoom
							tileX
							tileY
						}
						placesResult {
							placeId
							placeGeometryResult {
								geometryType
								geometry
							}
							placeTags {
								TagName
								TagPropertyKey
								TagPropertyValue
							}
						}
					}
				}
			}
			dataResults {
				dataType
				dataProperties {
					dataPropertyType
					categoryResults {
						dataPropCategoryType
						resultValue {
							quantity
							category
							resultAnnotations {
								resultAnnotation
							}
						}
					}
				}
			}
		}
	}
`;

export const GET_PLACES_IN_TILES = gql`
	query (
		$input: Input_farm_nurture_core_contracts_mva_GetPlacesInTilesRequest!
	) {
		getPlacesInTiles(input: $input) {
			statusResult {
				status
				errorCode
				errorMessages
				internalErrorCode
			}
			mapResults {
				geoStatusResult
				placeDataResult {
					placeNamespace
					placeSourceType
					placeVisibleType
					tileResults {
						mapTile {
							zoom
							tileX
							tileY
						}
						placesResult {
							placeId
							placeGeometryResult {
								geometryType
								geometry
							}
							placeTags {
								TagName
								TagPropertyKey
								TagPropertyValue
							}
						}
					}
				}
			}
			dataResults {
				dataType
				dataProperties {
					dataPropertyType
					categoryResults {
						dataPropCategoryType
						resultValue {
							quantity
							category
							resultAnnotations {
								resultAnnotation
							}
						}
					}
				}
			}
		}
	}
`;

export const GET_PLACES_BY_TILES = gql`
	query (
		$input: Input_farm_nurture_core_contracts_starship_GetTileInfoRequest!
	) {
		getPlacesByTiles(input: $input) {
			responseStatus {
				status
				statusReason
				errorCode
				reasons
				errorMessages
				internalErrorCode
			}
			tileResponse {
				env {
					namespace
					sourceType
					visibleType
				}
				places {
					geometry
					tags {
						TagName
						TagPropertyKey
						TagPropertyValue
						value {
							valueType
							stringValues
							boolValues
							int64Values
							int32Values
							floatValues
							nsvPlaceIdValues {
								PlaceNamespace
								PlaceSourceType
								PlaceVisibleType
								placeId
							}
							overlappingPlaceValues {
								overlapContext {
									cropSeason
									appName
								}
								overlapPercentage
								placeId
							}
						}
						PlaceTagId
					}
					referenceAttributes {
						referenceType
						attributes {
							key
							value {
								valueType
								numberValue
								stringValue
								boolValue
								int64Value
								int32Value
							}
						}
					}
					timeRange {
						startTime {
							seconds
						}
						endTime {
							seconds
						}
					}
					representationType
					sourceId
					placeId
					deleted
					overlap
				}
			}
		}
	}
`;

export const GET_AVAILABLE_LAYERS = gql`
	query (
		$input: Input_farm_nurture_core_contracts_mva_GetAvailableLayerRequest!
	) {
		getLayers(input: $input) {
			layers {
				PlaceNamespace
				PlaceGeometryType
				MinZoomLevel
				MaxZoomLevel
				PlaceSourceType
				PlaceVisibleType
			}
		}
	}
`;

export const GET_TEMPORAL_PLACES_BY_REFERENCES = gql`
	query (
		$input: Input_farm_nurture_core_contracts_starship_GetTemporalPlacesByReferencesRequest!
	) {
		GetTemporalPlacesByReferences(input: $input) {
			responseStatus {
				status
				statusReason
			}
			places {
				placeId
				overlap
				geometry
				representationType
				timeRange {
					startTime {
						seconds
					}
					endTime {
						seconds
					}
				}
				tags {
					TagName
					TagPropertyKey
					value {
						valueType
						boolValues
						stringValues
						floatValues
						int64Values
						int32Values
					}
				}
				referenceAttributes {
					referenceType
					attributes {
						key
						value {
							valueType
							int64Value
							stringValue
							boolValue
						}
					}
				}
			}
		}
	}
`;

export const GET_ALL_FILTER_TAGS = gql`
	query (
		$input: Input_farm_nurture_core_contracts_starship_GetAllFilterTagsRequest!
	) {
		getAllFilterTags(input: $input) {
			responseStatus {
				status
				statusReason
				errorCode
				internalErrorCode
			}
			tagValues {
				tagKey {
					tagName
					tagPropertyKey
					valueType
				}
				valueArray
			}
		}
	}
`;

export const GET_PLACES_MATRIX_BY_TILES = gql`
	query (
		$input: Input_farm_nurture_core_contracts_starship_GetPlacesMatrixByTilesRequest!
	) {
		getPlacesMatrixByTiles(input: $input) {
			responseStatus {
				status
				statusReason
				errorCode
				reasons
				errorMessages
				internalErrorCode
			}
			tileResponses {
				placesMatrix {
					placeId
					sourceId
					geometry
					startTime
					endTime
					createdTime
					updatedTime
					refJson
					tagJson
				}
				env {
					namespace
					sourceType
					visibleType
					modelVersion
				}
			}
		}
	}
`;

export const GET_ENTITIES_BY_TIME_RANGE = gql`
	query (
		$input: Input_farm_nurture_core_contracts_starship_GetEntitiesByTimeRangeRequest!
	) {
		getEntitiesByTimeRange(input: $input) {
			responseStatus {
				status
				statusReason
				errorCode
				internalErrorCode
			}
			responseMatrix
		}
	}
`;

export const GET_ALL_FILTER_TAGS_V2 = gql`
	query (
		$input: Input_farm_nurture_core_contracts_starship_GetAllFilterTagsRequestV2!
	) {
		getAllFilterTagsV2(input: $input) {
			responseStatus {
				status
				statusReason
				errorCode
				internalErrorCode
			}
			nodes {
				data {
					nodeType
					name
				}
				nodes {
					data {
						nodeType
						name
					}
					nodes {
						data {
							nodeType
							name
						}
						nodes {
							data {
								nodeType
								name
							}
							nodes {
								data {
									nodeType
									name
								}
							}
						}
					}
				}
			}
		}
	}
`;
